var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-card-events',{attrs:{"url":_vm.$apiUrl.getForumEventsUrl(_vm.$route.params),"item-avatar-size":100}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }